var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.config_footer).length != 0)?_c('div',{attrs:{"id":"remoteConfigurableFooter"}},[_c(_vm.currentFooter,{tag:"component",attrs:{"footer":_vm.config_footer,"media":_vm.config_media,"adaptiveType":_vm.the_adaptiveType},on:{"hook:mounted":_vm.onComponentMounted}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }